<script lang="ts">
	import Star from './Star.svelte'
	type StarSize = 'sm' | 'md' | 'lg'

	interface Props {
		value?: number
		readonly?: boolean
		onchange?: (value: number) => void
		size?: StarSize
	}

	let { value = 0, readonly = false, onchange, size = 'sm' }: Props = $props()
	let hoverValue = $state(0)

	const totalStars = 5
	const starColor = 'text-yellow-500'
	const emptyStarColor = 'text-brand-gray-3'

	const sizeClasses: Record<StarSize, string> = {
		sm: 'h-3 w-3',
		md: 'h-5 w-5',
		lg: 'h-7 w-7',
	}

	function handleClick(index: number) {
		if (!readonly) {
			value = index + 1
			onchange(value)
		}
	}

	function handleMouseEnter(index: number) {
		if (!readonly) {
			hoverValue = index + 1
		}
	}

	function handleMouseLeave() {
		hoverValue = 0
	}
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div class="flex items-center" onmouseleave={handleMouseLeave} aria-label="Star rating">
	{#each Array(totalStars) as _, index}
		<Star
			class={`${sizeClasses[size]} flex-shrink-0 ${!readonly ? 'cursor-pointer' : ''}`}
			{index}
			{readonly}
			{hoverValue}
			{value}
			{starColor}
			{emptyStarColor}
			onclick={() => handleClick(index)}
			onmouseenter={() => handleMouseEnter(index)}
		/>
	{/each}
</div>
